module.exports = __webpack_public_path__ + "static/media/agenda.16c1f319.jpg";